import * as React from 'react'

export const Redo2Icon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_redo)'>
        <path
          d='M1.57086 17.9497C1.57086 12.1041 6.31976 7.35351 12.1646 7.35013C14.6719 7.44774 16.275 8.09249 17.4996 8.94534C18.5484 9.67579 19.3389 10.56 20.2256 11.5498H16.5709C16.0186 11.5498 15.5704 11.998 15.5704 12.5503C15.5707 13.1023 16.0188 13.5493 16.5709 13.5493H21.5704C22.0975 13.5493 22.6152 13.37 23.003 12.9825C23.3907 12.5947 23.5713 12.077 23.5714 11.5498V6.55032C23.5714 5.99804 23.1231 5.54984 22.5709 5.54984C22.0186 5.54984 21.5704 5.99804 21.5704 6.55032V10.0528C20.7327 9.11713 19.8088 8.11725 18.6422 7.30472C17.0719 6.21114 15.0833 5.4572 12.2086 5.35062L12.1895 5.34915H12.1705C5.21836 5.34936 -0.42865 10.9976 -0.42865 17.9497C-0.428596 18.5018 0.0183449 18.95 0.570374 18.9502C1.12263 18.9502 1.57081 18.502 1.57086 17.9497Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_redo'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
})

Redo2Icon.displayName = 'Redo2Icon'
